<template>
	<div class="page">
		<div class="screenLine">
			<div class="screenLineL">
				<el-input v-model="keyword" @keyup.enter.native="changeSearch" placeholder="输入关键字" style="width:140px;margin-right: 16px;"></el-input>
				<el-select v-model="shopId" style="margin-right: 16px;" @change="changeSearch">
					<el-option v-for="item in [{shop_name:'全部门店',shop_id:''}].concat(shopList)" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id" >
					</el-option>
				</el-select>
				<el-select v-model="state" @change="changeSearch" placeholder="状态" style="width:130px;margin-right: 16px;">
					<el-option v-for="item in [{label:'全部',value:''},{label:'在职',value:1},{label:'离职',value:0}]" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-button type="warning" @click="reset">重置</el-button>
			</div>
			<div class="screenLineR">
				<!-- <el-button type="warning" >新建精华文章</el-button> -->
			</div>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" height="100%">
				<el-table-column prop="no" label="序号" width="50">
					<template slot-scope="scope">
						{{scope.$index+1}}
					</template>
				</el-table-column>
				<el-table-column label="姓名" >
					<template slot-scope="scope">
						{{scope.row.basic_info.nick_name}}
					</template>
				</el-table-column>
				<el-table-column label="手机号" width="120">
					<template slot-scope="scope" >
						{{scope.row.basic_info.user_mobile}}
					</template>
				</el-table-column>
				<el-table-column label="性别" >
					<template slot-scope="scope">
						{{scope.row.archives_info.sex}}
					</template>
				</el-table-column>
				<el-table-column label="角色" width="120">
					<template slot-scope="scope" >
						{{scope.row.archives_info.position}}
					</template>
				</el-table-column>
				<el-table-column label="登录账号" >
					<template slot-scope="scope">
						{{scope.row.basic_info.user_name}}
					</template>
				</el-table-column>
				<el-table-column label="所属门店" >
					<template slot-scope="scope">
						{{scope.row.shopName}}
					</template>
				</el-table-column>
				<el-table-column label="状态" >
					<template slot-scope="scope">
						{{scope.row.status===0?'离职':''}}
						{{scope.row.status===1?'在职':''}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="170">
					<template slot-scope="scope">
						<el-button @click="curItem=scope.row;drawerStaffEdit_state=true" type="text">编辑</el-button>
						<el-button v-if="$public.isNull(scope.row.auth_info.o2o.member_id)" @click="curItem = scope.row;dialogxcx_state=true;" type="text">关联小程序</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagePosi">
			<page style="padding:10px 0;" :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
		<!-- <div v-if="compContentDetail_state===true" style="width:100%;height: 100%;position: absolute;top:0;left:0;z-index: 5;background-color: #F5F5FA;padding:16px 16px;box-sizing: border-box;">
			<compContentDetail :id="curItem.id" :contentType="'文章'" @submit="submit_compContentDetail"></compContentDetail>
		</div> -->
		<div v-if="drawerStaffEdit_state">
			<drawerStaffEdit :row="curItem" @submit="submit_drawerStaffEdit"></drawerStaffEdit>
		</div>
		<!-- 关联小程序 -->
		<el-dialog title="关联小程序" :visible.sync="dialogxcx_state" width="500px" @close="xcxKeyword=''" :close-on-press-escape="false" :wrapperClosable="false" :modal-append-to-body="false" :close-on-click-modal="false">
			<div>
				<span style="padding-left:20px;">小程序手机号：</span>
				<el-input v-model="xcxKeyword" placeholder="请输入小程序手机号" style="width:200px;"></el-input>
				<el-button type="warning" style="margin-left: 10px;" @click="search_xcxKeyword">搜索</el-button>
			</div>
			<div class="dialogMsg" style="text-align: center;color: red;line-height: 30px;margin-top:30px;">{{xcxMemberInfo == null?'暂未查询到会员信息,无法关联':`${xcxMemberInfo.basic_info.nick_name} 可关联`}}</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogxcx_state=false;" >取 消</el-button>
				<el-button type="warning" @click="submit_dialogxcxKeyword" >关 联</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import drawerStaffEdit from "./drawer_staffEdit.vue"
	import page from "@/components/page.vue"
	export default {
		components:{page,drawerStaffEdit},
		data() {
			return {
				keyword:'', //关键字
				shopId:'',
				shopList:this.$store.state.allShopList,
				state:'',  // 在职离职状态
				
				// 列表
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData:[],
				
				// 编辑弹出
				drawerStaffEdit_state:false,
				curItem:{},
				// 关联小程序
				dialogxcx_state:false,
				xcxKeyword:'',
				xcxMemberInfo:null,
			}
		},
		computed:{
			
		},
		created(){
			
		},
		mounted(){
			this.getTableData()
		},
		methods:{
			// 编辑员工
			submit_drawerStaffEdit(obj){
				this.drawerStaffEdit_state = false
				if(obj.type==='success'){
					this.getTableData()
				}
			},
			// 关联小程序
			search_xcxKeyword(){
				let params = {
					mobile:this.xcxKeyword
				}
				this.$http.get(process.env.VUE_APP_baseData + '/api/MemberInfo',params).then(res => {
					if (res.code == 0) {
						this.xcxMemberInfo = res.data;
					}
				})
			},
			submit_dialogxcxKeyword(){
				if(this.xcxMemberInfo == null){
					this.$message({
						type: 'error',
						message: '请查询到会员信息，无法关联'
					});
					return
				}
				let params = {
					staffId:this.curItem._id,
					memberId:this.xcxMemberInfo.memberId,
				}
				this.$http.post(process.env.VUE_APP_baseData + '/api/StaffInfo/update/weixin',params).then(res => {
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: '已关联'
						});
						this.xcxKeyword = '';
						this.getTableData()
						this.dialogxcx_state = false;
					}
				})
			},
			del(row){
				this.$confirm('确定删除该条动态?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						id:row.id
					}
					let loading = this.$loading()
					this.$http.delete(process.env.VUE_APP_AppAdmin+'/api/Article/DeleteArticle', params).then(res => {
						loading.close();
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
			// 列表
			changeSearch(){
				this.page.page = 1;
				this.getTableData()
			},
			reset(){
				this.keyword = ''
				this.shopId = ''
				this.state = ''
				
				this.page.page = 1;
				this.getTableData()
			},
			changePage(num){
				this.page.page = num;
				this.getTableData()
			},
			getTableData(){
				let params = {
					keyword: this.keyword,
					// "shopId": this.shopId,
					position: '',
					status: this.state,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_baseData+'/api/staffinfo/list', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.tableData = res.data.data||[];
						this.page.total = res.data.count;
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.page{
		padding:16px 16px 65px 16px;height: 100%;box-sizing: border-box;position: relative;
		.screenLine{
			display: flex;justify-content: space-between;
			.screenLineL{
				
			}
			.screenLineR{
				
			}
		}
		.tableBox{
			padding:16px;border-radius: 8px;background-color: #fff;box-sizing: border-box;margin-top:16px;height: calc(100% - 56px);
		}
		
		.pagePosi{
			position: absolute;bottom:0;left:16px;right:16px;text-align:right;background-color: #fff;padding:0 10px;border-radius: 8px 8px 0 0;
		}
	}
</style>
